import { TileSettingsFocus } from '../../../../tamalelibs/models/tile.model';
import { TamDashboardTileType } from '../../../tam-dashboard/tam-dashboard.model';

export class TileSettingsConfig {
    name?: string;
    description?: string;
    focus?: TileSettingsFocus;
    screenFocusType?: number;
    hideFocusSetting?: boolean;
    type?: TamDashboardTileType;
    constructor() {
        this.name = '';
        this.description = '';
        this.focus = new TileSettingsFocus();
        this.hideFocusSetting = false;
    }
}
